module.exports = __webpack_public_path__ + "eb832669affeabd75400b85cf61a94a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/2095_teaser_image.jpg
// module id = 595
// module chunks = 0